import { render, staticRenderFns } from "./TechBaseSection.vue?vue&type=template&id=396c52e4&scoped=true"
import script from "./TechBaseSection.vue?vue&type=script&lang=js"
export * from "./TechBaseSection.vue?vue&type=script&lang=js"
import style0 from "./TechBaseSection.vue?vue&type=style&index=0&id=396c52e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396c52e4",
  null
  
)

export default component.exports